import React, { useCallback, useEffect, useRef, useState } from 'react'
import { Box, Button, FormControl, FormGroup, MenuItem, Select, Switch, TextField, IconButton, RadioGroup, FormControlLabel, Radio, Grid } from '@mui/material';
import swal from 'sweetalert';
import debounce from "lodash.debounce";
import GooglePlacesAutocomplete from 'react-google-autocomplete';
import { ApiKey } from '../utils/UtilityFunctions';
import DeleteIcon from "@mui/icons-material/Delete";
import i18next from 'i18next';

const FormQuestionsPreview = ({element, handleFormValues, formQuestions, formValues, showQuesAns, doctorProfile}) => {

  const numRef = useRef(null)
  const autocompleteRef = useRef(null);
  const [addressFound, setAddressFound] = useState(true);
  const [image, setImage] = useState(null);
  const [radioVal, setRadioVal] = useState('')
  const [depQuestionsList, setDepQuestionsList] = useState([])
  
  const handleFileChange = (event) => {
    const file = event.target.files?.[0]; // Optional chaining for safety
    if (!file) return;

    const reader = new FileReader();

    reader.onloadend = () => {
      if (reader.result) {
        const base64Image = reader.result; // Base64 string
        setImage(base64Image);
        handleFormValues(base64Image.split(",")[1], "signature");
      } else {
        console.error("FileReader failed to load the file.");
      }
    };

    reader.onerror = (err) => {
      console.error("FileReader error: ", err);
    };

    reader.readAsDataURL(file); // Convert to Base64
  };

  const handleRemoveImage = () => {
    setImage(null);
  };

  const handlePlaceSelected = useCallback(
    debounce((place) => {
      if (!place || !place.geometry) return;

      const location = place.geometry.location;
      const lat = location.lat();
      const lng = location.lng();
      console.log("Selected place:", place.formatted_address);
      console.log("Selected place: Lat:", lat, "Lng:", lng);
      handleFormValues({address: place.formatted_address, lat: lat, lng: lng}, "c_address");
    }, 2000),
    [] // only create debounced function once
  );

  useEffect(() => {
    checkPreFill()
  }, [])

  const checkPreFill = () => {
    let dependentList =
      element?.dependentQuestions?.length > 0 &&
      element?.dependentQuestions.filter((obj) =>
        obj.selectedOption.includes(element.value)
      );
    setDepQuestionsList(dependentList);
    if(element?.value && typeof element.value === 'object') {
      setRadioVal(Object.keys(element.value)[0])
    } else {
      element?.value && element.value && setRadioVal(element.value)
    }
  }

  const callSameComponent = () => (
    depQuestionsList?.length > 0 && depQuestionsList.map((ele, idx) => (
      <Grid item xs={12}>
        <FormQuestionsPreview 
          key={idx}
          element={ele} 
          handleFormValues={handleFormValues}
          formQuestions={formQuestions}
          formValues={formValues}
        />
      </Grid>
    ))
  )

  const renderQuestion = (element) => {
    let defValue
    if(element?.value && typeof element.value === 'object') {
      defValue = Object.keys(element.value)[0]
    } else {
      defValue = element.value
    }
    return (
      <div className='quesDiv'>
        {
          element.type === 'address' && !element.value ? 
            <>
              <div className='quesTitle addressTitle'>
                {element?.title}
                <Switch
                  checked={addressFound}
                  onChange={(e) => setAddressFound(e.target.checked)}
                />
              </div> 
            </> 
              :
          doctorProfile && 
          ( 
            element.commonIdentifier === 'name' || 
            element.commonIdentifier === 'email'
          ) ?
            <div className='quesTitle'>
              {element?.title}
              <span className='ml-5px mandatory'>*</span>
            </div>
              :
            <div className='quesTitle'>
              {element?.title}
            </div>
        }
        <div className='quesInput'>
          {
            showQuesAns ? 
              // <TextField
              //   variant='standard'
              //   value={defValue}
              //   disabled
              // />
              <p className='formAns'>{defValue}</p>
                : 
              getQuestionType(element)
          }
        </div>
        {!showQuesAns && callSameComponent()}
      </div>
    )
  };

  const getQuestionType = (element) => {
    switch (element.type) {
      case "text":
        return getTextType(element);
      case "number":
        return getNumberType(element);
      case "dropdown":
        return getDropdownType(element);
      case "radio":
        return getRadioType(element);
      case "address":
        return getAddressType(element);
      case "alphanumeric":
        return getAlphanumericType(element);
      case "signature":
        return getSignatureType(element);
      default:
        return getTextType(element);
    }
  };
  
  const getTextType = (element) => {
    return (
      <TextField 
        placeholder={element?.placeholder} 
        variant="outlined"
        onChange={(e) => handleFormValues(e.target.value, element?.commonIdentifier)}
        defaultValue={element.value && element.value}
        disabled={element.value && true}
      />
    );
  };
  
  const getNumberType = (element) => {
    return (
      <TextField
        defaultValue={element.value && element.value}
        disabled={element.value && true}
        inputRef={numRef}
        placeholder={element?.placeholder} 
        variant="outlined"
        inputProps={{
          maxLength: element?.commonIdentifier === 'phone' ? 15 : 3,
          minLength: element?.commonIdentifier === 'phone' ? 5 : 1,
          inputMode: 'numeric',       // Brings up number keyboard on mobile
          pattern: '[0-9]*',          // Accept only digits
        }}
        onInput={(e) => {
          e.target.value = e.target.value.replace(/[^0-9]/g, '');
        }}
        onChange={(e) => handleFormValues(e.target.value, element?.commonIdentifier)}
        onBlur={() => {
          if(element?.commonIdentifier === 'phone' && formValues.phone !== "" && formValues.phone.length < 3){
            swal({
              title: "Please enter a valid phone number",
              icon: "warning",
            }).then(() => {
              numRef.current?.focus(); // Re-focus after alert
            });
          } else if(element?.commonIdentifier === 'age' && (formValues.age !== "" && formValues.age < 1 || formValues.age > 120)){
            swal({
              title: "Please enter a valid age",
              icon: "warning",
            }).then(() => {
              numRef.current?.focus(); // Re-focus after alert
            });
          }
        }}
      />
    );
  }

  const getDropdownType = (element) => {
    return (
      <Select
        id="demo-simple-select"
        onChange={(e) => handleFormValues(e.target.value, element?.commonIdentifier)}
        className='genderSelect'
        value={formValues?.gender}
        label='Please select'
      >
        {
          element?.optionMap.map((o, index) => (
            <MenuItem key={index} value={o}>
              {o}
            </MenuItem>
          ))
        }
      </Select>
    )
  }

  const getRadioType = (element) => {
    return(
      <RadioGroup
        onChange={(e) => handleRadioChange(e, element)}
        value={radioVal}
      >
        {
          Object.keys(element?.optionMap).length > 0 && Object.keys(element?.optionMap).map((k) => {
            return(
              <FormControlLabel value={element.optionMap[k]} control={<Radio disabled={true}/>} label={element.optionMap[k]}/>
            )
          })
        }
      </RadioGroup>
    )  
  }

  const getAddressType = (element) => {
    return (
      <>
        {
          !addressFound || element.value ? 
            <TextField 
              defaultValue={element.value && element.value}
              disabled={element.value && true}
              placeholder={element?.placeholder} 
              variant="outlined"
              onChange={(e) => handleFormValues(e.target.value, element?.commonIdentifier)}
            />
              :
            <div className="googlePlaceDiv">
              <GooglePlacesAutocomplete
                className="googlePlaceTxtbox commonInputText"
                apiKey={ApiKey}
                onPlaceSelected={handlePlaceSelected}
                ref={autocompleteRef}
                options={{ types: ["establishment"] }}
                placeholder="Enter a location"
                style={{
                  width: "100%",
                  height: "40px",
                  padding: "10px",
                  fontSize: "16px",
                }}
              />
            </div> 
        }
      </>
    )
  }

  const getAlphanumericType = (element) => {
    return (
      <TextField
        defaultValue={element.value && element.value}
        disabled={element.value && true}
        inputRef={numRef}
        placeholder={element?.placeholder} 
        variant="outlined"
        inputProps={{
          maxLength: 15,
          minLength: 5,
          // inputMode: 'numeric',       // Brings up number keyboard on mobile
          pattern: '[A-Za-z0-9]*',          // Accept only digits
        }}
        onInput={(e) => {
          e.target.value = e.target.value.replace(/[^A-Za-z0-9]/g, '');
        }}
        onChange={(e) => handleFormValues(e.target.value, element?.commonIdentifier)}
        onBlur={() => {
          if(formValues.license_number !== "" && formValues.license_number.length < 6 || formValues.license_number.length > 15){
            swal({
              title: "Please enter a valid license number",
              icon: "warning",
            }).then(() => {
              numRef.current?.focus(); // Re-focus after alert
            });
          }
        }}
      />
    );
  }

  const getSignatureType = (element) => {
    return (
      <>
        {element.value && (
          <div className='d-flex justify-content-start align-items-center'>
            <img
              src={`data:image/jpeg;base64,${element.value}`}
              alt="Preview"
              style={{ width: 200, height: "auto", borderRadius: 8 }}
            />
          </div>
        )}
      </>
    )
  }

  return (
    <div className='formComponent preview'>
      <FormControl className='formControl'>
        <FormGroup>
          {renderQuestion(element)}
        </FormGroup>
      </FormControl>
    </div>
  )
}

export default FormQuestionsPreview